import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { StaffingContainer } from '@/features/admin/staffing/components/Staffing/StaffingContainer'
import { type AdminViewModel } from '@/features/admin/AdminViewModel'

export default observer(function AdminStaffingManagerContainer() {
  const vm = useOutletContext<AdminViewModel>()
  return <StaffingContainer vm={vm.staffingVm} />
})
